import { useEffect } from 'react'
import { useCookies } from 'src/Libs/cookies'
import { useDispatch } from 'react-redux'
import { setStoreInitialised } from 'src/State/Storage/StorageActions'
import { createEncryptedSystemDataStore } from 'src/Libs/system-data-handler/state/store'
import { useTypedSelector } from 'src/State/RootReducer'

const useInitSystemDataStore = (withContent: boolean): void => {
  const { cookies } = useCookies()
  const { cookieConsent } = cookies
  const dispatch = useDispatch()
  const userId = useTypedSelector(state => state.auth.userId)

  useEffect(() => {
    const initSystemDataStore = async (): Promise<void> => {
      if (IDBIndex && userId && withContent) {
        /** TODO: revert if needed for CPE-2234 */
        // const secret = await authFetch<{ secret: string }>({ path: `users/${id}/secret` })
        await createEncryptedSystemDataStore(undefined, userId, cookieConsent ?? false)
        dispatch(setStoreInitialised())
      }
    }
    initSystemDataStore()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, dispatch])
}

export default useInitSystemDataStore
